var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "turn" }, [
    _c(
      "svg",
      {
        staticClass: "heart-loader",
        attrs: {
          "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
          "xmlns:svg": "http://www.w3.org/2000/svg",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          viewBox: "0 0 90 90",
          version: "1.1",
        },
      },
      [
        _c("g", { staticClass: "heart-loader__group" }, [
          _c("path", {
            staticClass: "heart-loader__square",
            attrs: {
              "stroke-width": "1",
              fill: "none",
              d: "M0,30 0,90 60,90 60,30z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "heart-loader__circle m--left",
            attrs: {
              "stroke-width": "1",
              fill: "none",
              d: "M60,60 a30,30 0 0,1 -60,0 a30,30 0 0,1 60,0",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "heart-loader__circle m--right",
            attrs: {
              "stroke-width": "1",
              fill: "none",
              d: "M60,60 a30,30 0 0,1 -60,0 a30,30 0 0,1 60,0",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "heart-loader__heartPath",
            attrs: {
              "stroke-width": "2",
              d: "M60,30 a30,30 0 0,1 0,60 L0,90 0,30 a30,30 0 0,1 60,0",
            },
          }),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "turn__legend" }, [
      _vm._v("\n        Please turn your mobile\n    "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }